module.exports = __webpack_public_path__ + "img/main.ee20dd45.png";